import { useQuery } from '@tanstack/react-query';

import { RoutingFilter } from '../../serverApi/resources/RoutingFilter';

const ROUTING_FILTERS_QUERY_KEY = 'routingFilters';

export function getRoutingFiltersQueryKey(siteId: string | undefined) {
  return [ROUTING_FILTERS_QUERY_KEY, siteId];
}

export function useRoutingFilters(siteId: string | undefined) {
  return useQuery({
    queryKey: getRoutingFiltersQueryKey(siteId),
    queryFn: async () => {
      const result = await RoutingFilter.getRoutingFilters({ siteId: siteId as string });
      return result.success?.routingRules ?? [];
    },
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 0,
  });
}
